import { getUserTimeZoneDate } from '@src/packages/utils';
import { DateUtil } from '@src/packages/utils/dates';

import type { ScheduleDashboardSchedule } from '../types';

interface NestedSchedulePayload {
  startAt?: { _seconds: number; _nanoseconds: number };
  timeZone?: string;
}

/**
 * Start of a task schedule in the user's time zone, or null when the schedule
 * has no duration or no start date.
 */
export const getScheduleLocalStart = (
  schedule: ScheduleDashboardSchedule | undefined,
  userTimeZone?: string,
): Date | null => {
  const { startAt, timeZone } = (schedule?.schedule ?? {}) as NestedSchedulePayload;
  if (!schedule?.duration || !startAt) return null;

  const startAtMillis = DateUtil.getTimestampMs(startAt);
  if (startAtMillis == null) return null;

  return getUserTimeZoneDate(startAtMillis, timeZone, userTimeZone).jsDate;
};
